import { SwapMarket } from '../interface';
import { usePanoraSwap } from './panora';

export const useSwapMarket: () => SwapMarket = usePanoraSwap;
